export default __webpack_public_path__ + "5436484a150651be8c67163878b45429.png";